import { render, staticRenderFns } from "./AchievementFilesUpload.vue?vue&type=template&id=1bc82076&scoped=true"
import script from "./AchievementFilesUpload.vue?vue&type=script&lang=ts"
export * from "./AchievementFilesUpload.vue?vue&type=script&lang=ts"
import style0 from "./AchievementFilesUpload.vue?vue&type=style&index=0&id=1bc82076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc82076",
  null
  
)

export default component.exports